import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { policyMap } from '@/mocks/jiuchou-architecture';

export default function PolicyMap() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="政策 → 产品"
            title="把国家政策，落到具体产品与场景"
            subtitle="国家政策与项目功能不再是孤立的两个页面，而是「政策 → 能力 → 产品 → 场景 → 结果」的一条清晰映射。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 overflow-x-auto">
            <div className="min-w-[720px] rounded-lg border border-background-200 overflow-hidden">
              <div className="grid grid-cols-3 bg-foreground-950 text-background-50 text-sm font-medium">
                <div className="px-5 py-3">国家政策方向</div>
                <div className="px-5 py-3">九畴云铺能力</div>
                <div className="px-5 py-3">官网展示产品</div>
              </div>
              {policyMap.map((p, i) => (
                <div
                  key={p.policy}
                  className={`grid grid-cols-3 text-sm ${
                    i % 2 === 0 ? 'bg-background-50' : 'bg-background-100'
                  }`}
                >
                  <div className="px-5 py-3.5 font-medium text-foreground-950">{p.policy}</div>
                  <div className="px-5 py-3.5 text-foreground-600">{p.ability}</div>
                  <div className="px-5 py-3.5">
                    <span className="px-2.5 py-1 rounded-full bg-primary-100 text-primary-800 text-xs whitespace-nowrap">
                      {p.product}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={150}>
          <p className="mt-6 text-sm text-foreground-500 leading-relaxed text-center max-w-3xl mx-auto">
            2025 年数字乡村工作要点明确提出「数商兴农」「互联网+农产品出村进城」、农村电商供应链、县域商贸流通企业数字化转型以及农产品质量安全追溯等方向，这些正好成为官网「政策 → 产品」的映射依据。
          </p>
        </Reveal>
      </div>
    </section>
  );
}